//dynamically creates drop down with subpages under nav item on click

(function($){
	$('.nav_toplevel_pages a').on('click', function(event) {
		event.preventDefault();
		var menuLink = $(this);
		var index = $('.nav_toplevel_pages a').index(menuLink);
		var childLinks = $('.nav.nav-collapse .child-menu').eq(index);
		if(childLinks.find('li').length < 2){
			//if only one link then go to link
			window.location.href = childLinks.find('a').first().attr('href');
		}
		else{
			display_dropdown_links(menuLink, index, childLinks);
		}
	});
	$('.nav_toplevel_pages a').on('mouseenter', function(event) {
		var menuLink = $(this);
		var index = $('.nav_toplevel_pages a').index(menuLink);
		var childLinks = $('.nav.nav-collapse .child-menu').eq(index);
		if(childLinks.find('li').length >= 2){
			display_dropdown_links(menuLink, index, childLinks, 'hover');
		}
	});
	/*
	* Only hide the dropdown if triggered by hover and mouse does not go over dropdown
	*/
	$('.nav_toplevel_pages a').on('mouseleave', function(event) {
		var dropdown = $('#dropdown_menu');
		// if($('#dropdown_menu:hover').length != 0){
		// 	hide_dropdown(dropdown);
		// }
	});
	$('body').on('mouseleave', '#dropdown_menu', function(event) {
		hide_dropdown($(this));
	});

	var hide_dropdown = function(dropdown){
		dropdown.removeClass('currently_active');
	};

	var display_dropdown_links = function(menuLink, index, childLinks, eventType){
		//display sub-menu
		var dropdown = $('#dropdown_menu');
		if(dropdown.length < 1){
			$('body').append("<div id='dropdown_menu' class='nav_dropdown'><ul></ul></div>");
			dropdown = $('#dropdown_menu');
		}
		if(dropdown.hasClass('currently_active') && index === dropdown.data('current-index')){
			if(eventType !== 'hover'){
				hide_dropdown(dropdown);
			}
			return;
		}
		else{
			dropdown.addClass('currently_active');
		}
		dropdown.find('ul').html(childLinks.html());
		position_dropdown(menuLink);
		dropdown.data('current-index', index);
	};

	var position_dropdown = function($parentHeading){
		var marginTop = 16;
		var dropdown = $('#dropdown_menu');
		var offset = $parentHeading.offset();
		dropdown.css('top', offset.top + marginTop);
		dropdown.css('left', offset.left);
	};
	
	//have dropdown menu follow heading on page resize
	$(window).resize(function() {
		var dropdown = $('#dropdown_menu.currently_active');
		//only reposition dropdown if it is visible
		if(dropdown.length > 0){
			var index = dropdown.data('current-index');
			position_dropdown($('.nav_toplevel_pages a').eq(index));
		}
	});

})(jQuery);


